// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"FidAdmin_pageHeader__2-StM"};